(() => {
  if (window.leobelaCartDiscountInitialized) return;
  window.leobelaCartDiscountInitialized = true;

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-leobela-discount-form]');
    if (!form) return;

    event.preventDefault();

    const input = form.querySelector('input[name="discount"]');
    const error = form.querySelector('[data-discount-error]');
    const code = input?.value.trim();

    if (!code) {
      form.classList.add('has-error');
      if (error) error.hidden = false;
      input?.focus();
      return;
    }

    form.classList.remove('has-error');
    if (error) error.hidden = true;

    const shopifyRoot = window.Shopify?.routes?.root || '/';
    const root = shopifyRoot.endsWith('/') ? shopifyRoot : `${shopifyRoot}/`;
    const checkoutUrl = `${root}checkout`;
    const discountUrl =
      `${root}discount/${encodeURIComponent(code)}` +
      `?redirect=${encodeURIComponent(checkoutUrl)}`;

    window.location.assign(discountUrl);
  });

  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-leobela-discount-form] input[name="discount"]')) return;

    const form = event.target.closest('[data-leobela-discount-form]');
    const error = form?.querySelector('[data-discount-error]');

    form?.classList.remove('has-error');
    if (error) error.hidden = true;
  });
})();
